<template>
	<div class="container">
    <Banner :banner="banner" />
    <md-title :titleObj="modular1.titleData"></md-title>
    <md-list listClassName="indexMd1" :listdata="modular1.list"></md-list>
    <md-title :titleObj="modular2.titleData"></md-title>
    <md-list listClassName="indexMd2" :listdata="modular2.list"></md-list>
    <md-title :titleObj="modular3.titleData"></md-title>
    <md-list listClassName="indexMd3" :listdata="modular3.list"></md-list>
    <md-title :titleObj="modular4.titleData"></md-title>
    <md-title :titleObj="modular4.titleData2" style="margin-top:-25px;"></md-title>
    <RollList :list="modular4.conList"/>
  </div>
</template>
<script>
import Banner from "@/zqn/banner";
import MdTitle from "@/zqn/mdtitle";
import MdList from "@/zqn/mdlist";
import RollList from "@/zqn/rollList";
import { zqn } from "../utils/htmlContent";
export default {
	components: {
		Banner,
    MdList,
		MdTitle,
    RollList,
	},
	data() {
		return {
      // bannerSwiper:zqn.bannerSwiper,
			banner: zqn.banner,
			modular1: zqn.modular1,
			modular2: zqn.modular2,
      modular3: zqn.modular3,
      modular4: zqn.modular4,
 
		};
	},
	created() {},
	methods: {},
};
</script>
<style lang="scss" scoped>
 .swiper{
  width:750px;
  height:756px;
 }
 .homeMd4{
  margin:60px 20px;
  display:flex;
  flex-wrap: wrap;
  justify-content: space-between;
  img{
    display: block;
    width:345px;
    height:407px;
    margin-bottom:15px;
  }
}
</style>
<style lang="scss">
</style>
